import React, { useState, useEffect, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
import { useAppContext } from "../../App.jsx";
import { useQueries } from "@tanstack/react-query";
import {
  polytxnidlink,
  polytxnlink,
  q_prizebox_txns,
  q_prizebox_pop,
  q_que_txn,
  qiserr,
  qissuccesss,
} from "../../queries/queries.jsx";
import {
  cdelay,
  dec,
  getv,
  iso,
  iso_format,
  jstr,
  nils,
  trim2,
} from "../../utils/utils.jsx";
import {
  Card,
  Img,
  PopupCloseBtn,
  Tag,
  tablecn,
  tokenimgmap,
} from "../../components/utilityComps.jsx";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { CircularLoader, Loader01c } from "../../components/anims.jsx";
import colors from "tailwindcss/colors";
import { twMerge } from "tailwind-merge";
import PrizeBox from "../../contracts/PrizeBox/PrizeBox";
import { metamaskimg, polychainimg } from "../../utils/links.jsx";
import { PopUp } from "../../components/popup.jsx";
import { Link } from "react-router-dom";
import {
  ElementTag,
  FNoTag,
  GenderTag,
  TypeTag,
} from "../../components/ShortComps.jsx";
import { useThirdWebLoginContext } from "../ThirdWebLogin.jsx";
import { polygon } from "thirdweb/chains";
import {
  t3_contract_call,
  t3_wait_for_txn,
} from "../../contracts/contract_funcs.jsx";
import { useAuthContext } from "../../wrappers/AuthWrapper.jsx";
import { useLayoutContext } from "../../components/Layout.jsx";
import "./prizebox-animations.css";

// Constants and utilities
export const boxtypemap = {
  1: {
    name: "Prize Box",
    img: "https://i.imgur.com/6M8DdOR.png",
  },
  2: {
    name: "Big Box",
    img: "https://cdn.dnaracing.run/imgs/img_bigbox.png",
  },
};

export const asset_img_table = _.chain([
  { idx: "corelootbox_v2", key: "corelootbox_v2" },
  { idx: "custom_1v1_skin", key: "custom_1v1_skin" },
  { idx: "dez_105000", key: "dez_105000" },
  { idx: "dez_1250", key: "dez_1250" },
  { idx: "dez_2000", key: "dez_2000" },
  { idx: "dez_20000", key: "dez_20000" },
  { idx: "dez_2500", key: "dez_2500" },
  { idx: "dez_10000", key: "dez_10000" },
  { idx: "dez_30000", key: "dez_30000" },
  { idx: "dez_3500", key: "dez_3500" },
  { idx: "dez_400", key: "dez_400" },
  { idx: "dez_40000", key: "dez_40000" },
  { idx: "dez_5000", key: "dez_5000" },
  { idx: "dez_6000", key: "dez_6000" },
  { idx: "dez_8000", key: "dez_8000" },
  { idx: "dez_850", key: "dez_850" },
  { idx: "fbike_f2", key: "fbike_f2" },
  { idx: "fbike_f3", key: "fbike_f3" },
  { idx: "fbike_f4", key: "fbike_f4" },
  { idx: "fbike_f5", key: "fbike_f5" },
  { idx: "fbike_f6", key: "fbike_f6" },
  { idx: "fbike_f7", key: "fbike_f7" },
  { idx: "fbike_f8", key: "fbike_f8" },
  { idx: "matic_10", key: "matic_10" },
  { idx: "matic_18", key: "matic_18" },
  { idx: "matic_2", key: "matic_2" },
  { idx: "matic_3", key: "matic_3" },
  { idx: "matic_5", key: "matic_5" },
  { idx: "matic_8", key: "matic_8" },
  { idx: "sgc_400", key: "sgc_400" },
  { idx: "sgc_500", key: "sgc_500" },
  { idx: 2, key: "weth_0.0100" },
  { idx: 3, key: "dez_4000" },
  { idx: 6, key: "weth_0.0120" },
  { idx: 7, key: "weth_0.0200" },
  { idx: 8, key: "weth_0.0500" },
  { idx: 9, key: "weth_0.1500" },
  { idx: 10, key: "weth_0.2500" },
  { idx: 14, key: "bgc_100" },
  { idx: 15, key: "matic_500" },
  { idx: 16, key: "sgc_1000" },
  { idx: 17, key: "matic_250" },
  { idx: 18, key: "bgc_250" },
  { idx: 19, key: "matic_75" },
  { idx: 21, key: "matic_30" },
  { idx: 22, key: "matic_150" },
  { idx: 26, key: "bgc_50" },
  { idx: 28, key: "matic_425" },
  { idx: 30, key: "skin" },
  { idx: "usd_100", key: "usd_100" },
  { idx: "usd_250", key: "usd_250" },
  { idx: "usd_500", key: "usd_500" },
  { idx: "usd_1000", key: "usd_1000" },
  { idx: "usd_5000", key: "usd_5000" },
  { idx: "usd_100", key: "ad-usd_100" },
  { idx: "usd_250", key: "ad-usd_250" },
  { idx: "usd_500", key: "ad-usd_500" },
  { idx: "usd_1000", key: "ad-usd_1000" },
  { idx: "usd_5000", key: "ad-usd_5000" },
  { idx: "bgc_10", key: "bgc_10" },
  { idx: "bgc_20", key: "bgc_20" },
  { idx: "bigbox", key: "bigbox" },
  { idx: "seasonblastnft", key: "seasonblastnft" },

  { idx: "seasonblastnft", key: "seasonblastnft" },

  { idx: "dez-usd_2", key: "dez-usd_2" },
  { idx: "dez-usd_200", key: "dez-usd_200" },
])
  .keyBy("key")
  .mapValues("idx")
  .value();

export const gen_asset_img = (a) => {
  let key = null;
  // console.log("gen_asset_img", a);
  if (a.type == "USD") {
    key = a.key;
  } else if (["WETH", "DEZ", "MATIC", "SGC", "BGC"].includes(a.type)) {
    let val = a.amt < 1 ? dec(a.amt, 4) : parseInt(a.amt);
    key = `${a.type.toLowerCase()}_${val}`;
  } else if (a.type == "corelootbox_v2") {
    key = "corelootbox_v2";
  } else if (a.type == "custom_1v1_skin") {
    key = "custom_1v1_skin";
  } else if (a.type == "skin") {
    key = `skin`;
  } else if (a.type == "fbike") {
    let fno = getv(a, "info.fno");
    key = `fbike_f${fno}`;
  } else {
    key = a.key;
  }

  if (nils(key)) return null;
  let idx = asset_img_table[key];
  if (nils(idx)) idx = key;
  let imglink = `https://cdn.dnaracing.run/prizebox/${idx}.png`;
  return imglink;
};

export const gen_asset_i = (a) => {
  let idx = asset_img_table[a];
  return `https://cdn.dnaracing.run/prizebox/${idx}.png`;
};

// ==================================================================================
// MODERN DESIGN SYSTEM COMPONENTS
// ==================================================================================

// Glass morphism utility classes and components
export const GlassCard = ({ children, className = "", ...props }) => {
  return (
    <div
      className={twMerge(
        "glass-card bg-r3reg/10 backdrop-blur-xl border border-r3lig/20 rounded-2xl shadow-xl",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const GradientCard = ({ children, className = "", ...props }) => {
  return (
    <div
      className={twMerge(
        "bg-gradient-to-br from-r3lig/20 via-r3reg/15 to-r3dark/25 backdrop-blur-xl border border-r3lig/30 rounded-2xl shadow-2xl",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const GlowButton = ({
  children,
  className = "",
  variant = "primary",
  ...props
}) => {
  const variants = {
    primary:
      "bg-gradient-to-r from-r3reg to-r3dark text-white hover:from-r3lig hover:to-r3reg shadow-lg hover:shadow-r3reg/50 hover:shadow-2xl",
    secondary:
      "bg-gradient-to-r from-gray-600/40 to-gray-700/40 text-gray-300 hover:text-white border border-gray-500/30 hover:border-gray-400/50",
    success:
      "bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-400 hover:to-green-500 shadow-lg hover:shadow-green-500/50",
    danger:
      "bg-gradient-to-r from-red-500 to-red-600 text-white hover:from-red-400 hover:to-red-500 shadow-lg hover:shadow-red-500/50",
  };

  return (
    <button
      className={twMerge(
        "px-6 py-3 rounded-xl font-digi font-semibold transition-all duration-300 transform hover:scale-105 active:scale-95",
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};

// Animated background orbs
export const BackgroundOrbs = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-r3lig/20 rounded-full blur-3xl animate-pulse animate-float" />
      <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-r3dark/20 rounded-full blur-3xl animate-pulse animate-float animation-delay-2000" />
      <div className="absolute top-[40%] right-[15%] w-64 h-64 bg-r3reg/15 rounded-full blur-2xl animate-pulse animate-float animation-delay-4000" />
    </div>
  );
};

// Modern loading spinner
export const ModernLoader = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  return (
    <div className={twMerge("relative", sizes[size], className)}>
      <div className="absolute inset-0 border-2 border-r3lig/30 rounded-full"></div>
      <div className="absolute inset-0 border-2 border-transparent border-t-r3lig rounded-full spin-anim"></div>
    </div>
  );
};

// Shimmer skeleton components
export const ShimmerBox = ({
  className = "",
  width = "w-full",
  height = "h-4",
}) => {
  return (
    <div
      className={twMerge(
        "relative overflow-hidden bg-r3dark/20 rounded",
        width,
        height,
        className,
      )}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
    </div>
  );
};

// Transaction Table Skeleton
export const TransactionTableSkeleton = () => {
  return (
    <GlassCard className="h-full hover-lift flex flex-col mt-2">
      {/* Header skeleton */}
      <div className="p-6 border-b border-r3lig/20 flex-shrink-0">
        <div className="flex items-center gap-3">
          <ShimmerBox className="rounded-full" width="w-8" height="h-8" />
          <ShimmerBox width="w-32" height="h-5" />
          <div className="flex-1"></div>
          <ShimmerBox width="w-6" height="h-4" />
        </div>
      </div>

      {/* Transaction items skeleton */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {[...Array(5)].map((_, idx) => (
          <div
            key={idx}
            className="bg-r3dark/10 border border-r3lig/20 rounded-xl p-3"
          >
            {/* Top Row: Transaction Hash + Date */}
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-1.5">
                <ShimmerBox className="rounded-full" width="w-3" height="h-3" />
                <ShimmerBox width="w-20" height="h-3" />
              </div>
              <ShimmerBox width="w-16" height="h-3" />
            </div>

            {/* Main Content Row */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 flex-1">
                <ShimmerBox className="rounded-full" width="w-5" height="h-5" />
                <div className="min-w-0 space-y-1">
                  <ShimmerBox width="w-16" height="h-4" />
                  <ShimmerBox width="w-24" height="h-3" />
                </div>
              </div>
              <ShimmerBox width="w-20" height="h-6" className="rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </GlassCard>
  );
};

// Confetti system
export const createConfetti = (container, count = 150) => {
  const colors = [
    "#2a9fff",
    "#1d90ff",
    "#0066cc",
    "#ffffff",
    "#a78bfa",
    "#ec4899",
  ];

  for (let i = 0; i < count; i++) {
    const confetti = document.createElement("div");
    confetti.className = "confetti-piece";
    confetti.style.cssText = `
      position: absolute;
      width: ${Math.random() * 8 + 4}px;
      height: ${Math.random() * 8 + 4}px;
      background-color: ${colors[Math.floor(Math.random() * colors.length)]};
      left: ${Math.random() * 100}vw;
      animation: confetti-fall ${Math.random() * 3 + 2}s linear forwards;
      animation-delay: ${Math.random() * 2}s;
      z-index: 1000;
      border-radius: 2px;
      opacity: 0;
    `;
    container.appendChild(confetti);
  }

  // Clean up after animation
  setTimeout(() => {
    const pieces = container.querySelectorAll(".confetti-piece");
    pieces.forEach((piece) => piece.remove());
  }, 5000);
};

// 3D Box Animation Component
export const AnimatedBox3D = ({
  isOpen = false,
  isRumbling = false,
  boxImage,
  className = "",
  onClick,
}) => {
  return (
    <div className={twMerge("relative perspective-1000", className)}>
      <div
        className={twMerge(
          "relative transform-gpu transition-all duration-500 cursor-pointer",
          "hover:scale-105",
          isRumbling && "animate-bounce",
          isOpen && "animate-pulse",
        )}
        onClick={onClick}
        style={{
          transformStyle: "preserve-3d",
          transform: "rotateX(-10deg) rotateY(-15deg)",
        }}
      >
        {/* Glow effect behind box */}
        <div className="absolute inset-0 bg-r3lig/30 blur-2xl scale-110 rounded-2xl animate-pulse" />

        {/* Main box image */}
        <div className="relative z-10">
          <Img
            img={boxImage}
            className="w-full h-full object-cover rounded-2xl shadow-2xl"
          />
        </div>

        {/* Light beam effect for opening */}
        {isOpen && (
          <div className="absolute inset-0 bg-gradient-radial from-white/80 via-r3lig/40 to-transparent animate-ping rounded-2xl" />
        )}
      </div>
    </div>
  );
};

// Modern Progress Indicator
export const ProgressSteps = ({ steps, currentStep, className = "" }) => {
  return (
    <div
      className={twMerge(
        "flex items-center justify-center space-x-4",
        className,
      )}
    >
      {steps.map((step, index) => (
        <div key={step.key} className="flex items-center">
          <div
            className={twMerge(
              "w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300",
              index < currentStep
                ? "bg-green-500 text-white shadow-lg shadow-green-500/50"
                : index === currentStep
                  ? "bg-r3reg text-white shadow-lg shadow-r3reg/50 animate-pulse"
                  : "bg-gray-600/50 text-gray-400 border border-gray-500/30",
            )}
          >
            {index < currentStep ? "✓" : index + 1}
          </div>
          {index < steps.length - 1 && (
            <div
              className={twMerge(
                "w-16 h-1 mx-2 rounded-full transition-all duration-500",
                index < currentStep ? "bg-green-500" : "bg-gray-600/30",
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
};

// Components
export const ClosedBox = ({ boxtype }) => {
  const appcon = useAppContext();
  const { psearch, upd_psearch } = appcon;

  const aucon = useAuthContext();
  const { vault, auth, aumode } = aucon;
  const t3con = useThirdWebLoginContext();
  const { thirdweb_client, active_account } = t3con;
  const bmap = boxtypemap[boxtype];

  const pcon = usePrizeboxContext();
  const { qo_txns, set_box_error } = pcon;

  const [resp, set_resp] = useState({});
  const [count_loading, set_count_loading] = useState(true);
  const [loading, set_loading] = useState(false);
  const [closed_n, set_closed_n] = useState(0);

  const update_closed = async () => {
    try {
      set_count_loading(true);
      const con =
        aumode === "thirdweb"
          ? await PrizeBox.get_contract({ nosigner: true, rpc: polygon.rpc })
          : await PrizeBox.get_contract();
      let n = await con.accountOwns(vault, boxtype);
      set_count_loading(false);
      return set_closed_n(n);
    } catch (err) {
      console.log(err);
      set_count_loading(false);
      setTimeout(update_closed, 5 * 1e3);
    }
  };

  useEffect(() => {
    let interval = null;
    if (auth) {
      setTimeout(update_closed, 2 * 1e3);
      interval = setInterval(update_closed, 2 * 60 * 1e3);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [auth]);

  const open_box = async () => {
    try {
      set_loading(true);
      set_resp({});
      set_box_error(null);

      const con =
        aumode === "thirdweb"
          ? await PrizeBox.get_contract({ nosigner: true, rpc: polygon.rpc })
          : await PrizeBox.get_contract();

      let resp = null;
      if (aumode === "thirdweb") {
        upd_psearch({ boxopentx: "waiting_hash" });
        resp = await t3_contract_call(
          "prizebox",
          "openLootbox",
          [1, boxtype],
          "txn",
          false,
          { active_account },
        );
        upd_psearch({ boxopentx: resp.hash });
        resp = await t3_wait_for_txn(resp.hash);
      } else {
        upd_psearch({ boxopentx: "confirm_metamask" });
        resp = await con.openLootbox(1, boxtype);
        console.log(resp);
        resp = await resp.wait();
        console.log(resp);
      }

      if (nils(resp.hash)) throw new Error("Transaction failed");
      upd_psearch({ boxopentx: resp.hash });
      await q_que_txn({
        hash: resp.hash,
        vault,
        service: "prizebox",
      }).queryFn();

      await cdelay(5000);
      set_loading(false);
      setTimeout(update_closed, 5 * 1e3);
      setTimeout(qo_txns.refetch, 40 * 1e3);
    } catch (err) {
      console.log(err);
      set_loading(false);
      set_resp({ err: err.message });
      set_box_error(err.message);
    }
  };

  return (
    <div className="w-full">
      <GlassCard className="p-8 text-center w-full max-w-2xl mx-auto hover-lift">
        <h3 className="font-digi text-xl md:text-2xl text-r3lig mb-6">
          {bmap.name}
        </h3>

        {/* Box Image with Glow */}
        <div className="relative mb-6 group">
          <div className="relative w-48 h-48 md:w-64 md:h-64 mx-auto">
            {/* Gradient Glow Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-r3lig/30 via-r3reg/20 to-r3dark/30 rounded-3xl blur-2xl scale-110 animate-pulse" />

            {/* Box Image */}
            <div className="relative z-10 group-hover:scale-105 transition-transform duration-500">
              <Img
                img={bmap.img}
                className="w-full h-full object-contain rounded-2xl shadow-2xl"
              />
            </div>

            {/* Hover Glow Enhancement */}
            <div className="absolute inset-0 bg-gradient-to-br from-r3lig/20 to-r3reg/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl scale-125" />
          </div>
        </div>

        {/* Counter Display */}
        <div className="mb-8">
          {!auth ? (
            <div className="h-8"></div>
          ) : count_loading ? (
            <div className="flex justify-center">
              <ModernLoader size="md" />
            </div>
          ) : (
            <div className="space-y-2">
              <p className="text-4xl md:text-5xl font-digi font-bold text-r3lig animate-glow-pulse rounded-lg px-3 py-1">
                {closed_n}
              </p>
              <p className="text-gray-400 resp-text-0">
                {closed_n === 1 ? "Box Available" : "Boxes Available"}
              </p>
            </div>
          )}
        </div>

        {/* Action Button */}
        {closed_n > 0 ? (
          <div className="flex justify-center">
            <GlowButton
              onClick={() => {
                if (loading) return;
                open_box();
              }}
              variant="primary"
              disabled={loading}
              className={twMerge(
                "px-8 py-4 text-lg relative",
                loading && "opacity-50 cursor-not-allowed",
              )}
            >
              {loading ? (
                <div className="flex items-center gap-3">
                  <ModernLoader size="sm" />
                  <span>Opening...</span>
                </div>
              ) : (
                "Open 1 Box"
              )}
            </GlowButton>
          </div>
        ) : (
          <div className="flex justify-center">
            <div className="px-8 py-4 text-gray-500 font-digi text-lg">
              No boxes available
            </div>
          </div>
        )}

        {/* Error Display */}
        {!nils(resp.err) && (
          <div className="mt-6 p-4 bg-red-500/20 border border-red-500/50 rounded-xl">
            <p className="text-red-300 resp-text--1 break-words">{resp.err}</p>
          </div>
        )}
      </GlassCard>
    </div>
  );
};

export const PrizeBoxSection = () => {
  return (
    <div className="fr-sc resp-gap-2">
      <ClosedBox boxtype={1} />
    </div>
  );
};

export const BigBoxSection = () => {
  return (
    <div className="fr-sc resp-gap-2">
      <ClosedBox boxtype={2} />
    </div>
  );
};

export const ViewBoxAssets = ({ t, bmap }) => {
  const [open, set_open] = useState(false);

  const close_popup = () => {
    set_open(false);
  };

  const boxes = useMemo(
    () => getv(t, "connects_post.sel_boxes") || [],
    [jstr(t)],
  );

  // Check if it's a single box with single asset for special view
  const isSingleAsset = useMemo(() => {
    if (boxes.length !== 1) return false;
    const b = bmap[boxes[0]];
    return !nils(b) && b?.assets?.length === 1;
  }, [boxes, bmap]);

  // Single Asset Modal (Revealer Style)
  const singleAssetModal = () => {
    const boxid = boxes[0];
    const b = bmap[boxid];
    const asset = b?.assets?.[0];
    const m = getv(b, 'mintmap.0');
    const nonmintable = m?.nonmintable === true;
    const minted = !nils(m) && !nils(m?.txid);
    const img = gen_asset_img(asset);

    return (
      <div className="fixed inset-0 z-[150] backdrop-blur-md bg-black/70">
        {/* Close Button */}
        <div className="absolute top-6 right-6 z-[200]">
          <button
            onClick={close_popup}
            className="w-10 h-10 rounded-full bg-black/30 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white hover:bg-black/50 transition-colors duration-200"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="w-full h-full flex flex-col items-center justify-center p-8 space-y-8">
          {/* Row 1: Transaction Info */}
          <GlassCard className="px-6 py-3 animate-fade-in-up">
            <div className="flex items-center gap-4 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4">
                  <Img img={polychainimg} />
                </div>
                <Link
                  target="_blank"
                  to={polytxnidlink(t.id)}
                  className="text-r3lig hover:text-white font-mono transition-colors"
                >
                  {t.id.slice(0, 8)}...{t.id.slice(-8)}
                </Link>
              </div>
              <div className="w-px h-4 bg-r3lig/30"></div>
              <div className="text-gray-400">
                Opened {iso_format(getv(t, "date"))}
              </div>
            </div>
          </GlassCard>

          {/* Row 2: Box & Mint Status */}
          <GlassCard className="px-6 py-3 animate-fade-in-up animation-delay-300">
            <div className="flex items-center gap-6 text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-400">Box:</span>
                <span className="text-r3lig font-mono">#{trim2(boxid, 6, 6)}</span>
              </div>
              <div className="w-px h-4 bg-r3lig/30"></div>
              <div className="flex items-center gap-2">
                {nonmintable ? null : minted ? (
                  <Link
                    target="_blank"
                    to={polytxnidlink(m.txid)}
                    className="flex items-center gap-2 hover:bg-r3dark/20 px-2 py-1 rounded-lg transition-colors group"
                  >
                    <div className="flex items-center gap-1.5">
                      <span className="text-green-400 group-hover:text-green-300">✓ Minted</span>
                      <div className="w-4 h-4">
                        <Img img={polychainimg} />
                      </div>
                    </div>
                    <span className="text-green-300 hover:text-green-200 font-mono transition-colors">
                      {iso_format(m.date)}
                    </span>
                  </Link>
                ) : (
                  <>
                    <ModernLoader size="sm" />
                    <span className="text-orange-400">Processing mint...</span>
                  </>
                )}
              </div>
            </div>
          </GlassCard>

          {/* Main Prize Display */}
          <div className="text-center space-y-8 animate-fade-in-up animation-delay-600">
            {/* Prize Image - Large */}
            <div className="relative">
              {/* Multiple layered glow effects */}
              <div className="absolute inset-0 bg-gradient-to-br from-r3lig/40 to-r3reg/40 blur-3xl animate-pulse rounded-full scale-150" />
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-orange-500/20 blur-2xl animate-pulse rounded-full scale-125" />
              
              {/* Prize image */}
              <div className="relative z-10 w-80 h-80 mx-auto">
                {!nils(img) ? (
                  <Img
                    img={img}
                    className="w-full h-full object-contain rounded-2xl shadow-2xl"
                  />
                ) : (
                  <div className="w-full h-full bg-r3dark/20 rounded-2xl flex items-center justify-center">
                    <span className="text-gray-500 text-6xl">🎁</span>
                  </div>
                )}
                {/* Shimmer effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer-alternate rounded-2xl" />
              </div>
            </div>

            {/* Prize Title */}
            <div className="space-y-2">
              <h2 className="text-r3lig font-digi text-4xl animate-glow-pulse rounded-xl px-4 py-2">
                {asset?.type} {asset?.amt}
              </h2>
              <p className="text-gray-300 text-lg">
                🎉 Prize Successfully Awarded!
              </p>
            </div>

            {/* Special Asset Details */}
            {["fbike", "skin", "custom_1v1_skin"].includes(asset?.type) && (
              <div className="max-w-md mx-auto">
                {asset?.type === "fbike" && (
                  <>
                    {minted ? (
                      <GlassCard className="p-4">
                        <Link
                          target="_blank"
                          to={`https://market.dnaracing.run/asset/core/${getv(m, "hinfo.hid")}`}
                          className="block hover:bg-r3dark/20 p-2 rounded-lg transition-colors"
                        >
                          <div className="space-y-3">
                            <div className="flex items-center justify-center gap-3">
                              <span className="text-r3lig font-digi text-lg">
                                #{getv(m, "hinfo.hid")}
                              </span>
                              <span className="text-white font-digi text-lg">
                                {getv(m, "hinfo.name")}
                              </span>
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                              <ElementTag element={getv(m, "hinfo.element")} />
                              <TypeTag type={getv(asset, "info.type")} />
                              <FNoTag fno={getv(m, "hinfo.fno")} />
                              <GenderTag gender={getv(m, "hinfo.gender")} />
                            </div>
                          </div>
                        </Link>
                      </GlassCard>
                    ) : (
                      <GlassCard className="p-4">
                        <p className="text-gray-300">
                          Random {_.capitalize(getv(asset, "info.type"))} Bike F{getv(asset, "info.fno")}
                        </p>
                      </GlassCard>
                    )}
                  </>
                )}

                {["skin", "custom_1v1_skin"].includes(asset?.type) && (
                  <>
                    {minted && (
                      <GlassCard className="p-4 mb-4">
                        <Link
                          target="_blank"
                          to={`https://market.dnaracing.run/asset/skin/${getv(m, "skin_info.skinid")}`}
                          className="block hover:bg-r3dark/20 p-2 rounded-lg transition-colors"
                        >
                          <div className="space-y-2 text-center">
                            <div className="text-r3lig font-digi">
                              Skin ID: #{getv(m, "skin_info.skinid")}
                            </div>
                            <div className="text-sm space-y-1">
                              <div>
                                <span className="text-gray-400">Rarity: </span>
                                <span className="text-r3lig">{getv(m, "skin_info.rarity")}</span>
                              </div>
                              <div>
                                <span className="text-gray-400">Order: </span>
                                <span className="text-r3lig">{getv(m, "skin_info.name")}</span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </GlassCard>
                    )}
                    
                    <GlassCard className="p-4 bg-yellow-500/5 border-yellow-500/20">
                      <p className="text-yellow-300 text-sm">
                        💬 Please contact staff via Discord support channel
                      </p>
                    </GlassCard>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const modalContent = (
    <div className="fixed inset-0 z-[150] backdrop-blur-md bg-black/60">
      {/* Close Button - Top Right */}
      <div className="absolute top-6 right-6 z-[200]">
        <button
          onClick={close_popup}
          className="w-10 h-10 rounded-full bg-black/30 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white hover:bg-black/50 transition-colors duration-200"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Modal Content - Centered */}
      <div className="w-full h-full flex items-center justify-center p-4">
        <GlassCard className="w-full max-w-4xl max-h-[85vh] overflow-hidden animate-modal-entrance">
          {/* Header */}
          <div className="p-6 border-b border-r3lig/20 flex-shrink-0">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-r3reg to-r3dark flex items-center justify-center">
                <span className="text-white text-lg">📦</span>
              </div>
              <div>
                <h2 className="text-r3lig font-digi text-xl animate-glow-pulse rounded-lg px-3 py-1">
                  Box Assets Overview
                </h2>
                <p className="text-gray-400 text-sm mt-1">
                  {`${boxes.length} Box${boxes.length > 1 ? "es" : ""} opened`}
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6">
            {boxes.map((boxid, i) => {
              let b = bmap[boxid];
              return (
                <GradientCard key={boxid} className="p-6 hover-lift">
                  {/* Box Header */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-r3lig/30 flex items-center justify-center">
                      <span className="text-r3lig text-sm font-bold">#{i + 1}</span>
                    </div>
                    <div>
                      <h3 className="text-r3lig font-digi text-lg">
                        Box {i + 1}
                      </h3>
                      <p className="text-gray-400 text-xs font-mono">
                        ID: {trim2(boxid, 6, 6)}
                      </p>
                    </div>
                  </div>

                  {/* Empty Box State */}
                  {(nils(b) || _.isEmpty(b?.assets)) && (
                    <div className="text-center py-8">
                      <div className="text-4xl mb-2 opacity-50">📭</div>
                      <p className="text-gray-400">Empty Box</p>
                    </div>
                  )}

                  {/* Assets Grid */}
                  {!_.isEmpty(b?.assets) && (
                    <div className="grid gap-4">
                      {b.assets.map((a, j) => {
                        let m = getv(b, `mintmap.${j}`);
                        let nonmintable = m?.nonmintable === true;
                        let minted = !nils(m) && !nils(m?.txid);
                        let img = gen_asset_img(a);
                        
                        return (
                          <div key={j} className="bg-r3dark/20 border border-r3lig/20 rounded-xl p-4">
                            {/* Asset Header */}
                            <div className="flex items-center justify-between mb-3">
                              <div className="flex items-center gap-2">
                                <span className="w-6 h-6 bg-r3reg/30 rounded-full flex items-center justify-center text-xs font-bold text-r3lig">
                                  {j + 1}
                                </span>
                                <span className="text-gray-300 text-sm font-digi">
                                  Asset {j + 1}
                                </span>
                              </div>

                              {/* Mint Status */}
                              {nonmintable ? null : minted ? (
                                <Link
                                  target="_blank"
                                  to={polytxnidlink(m.txid)}
                                  className="flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors"
                                >
                                  <div className="w-4 h-4">
                                    <Img img={polychainimg} />
                                  </div>
                                  <span className="text-xs">
                                    minted {iso_format(m.date)}
                                  </span>
                                </Link>
                              ) : (
                                <div className="flex items-center gap-2 text-orange-400">
                                  <ModernLoader size="sm" />
                                  <span className="text-xs">Processing...</span>
                                </div>
                              )}
                            </div>

                            {/* Asset Content */}
                            <div className="flex flex-col sm:flex-row gap-4 items-center">
                              {/* Asset Image */}
                              <div className="flex-shrink-0">
                                {!nils(img) && (
                                  <div className="w-20 h-20 relative">
                                    <div className="absolute inset-0 bg-gradient-to-br from-r3lig/20 to-r3reg/20 rounded-lg blur-md" />
                                    <Img 
                                      img={img} 
                                      className="relative z-10 w-full h-full object-contain rounded-lg shadow-lg"
                                    />
                                  </div>
                                )}
                              </div>

                              {/* Asset Info */}
                              <div className="flex-1 text-center sm:text-left">
                                <div className="text-r3lig font-digi text-lg mb-2">
                                  {a.type} {a.amt}
                                </div>

                                {/* Special Asset Details */}
                                {["fbike", "skin", "custom_1v1_skin"].includes(a.type) && (
                                  <div className="space-y-2">
                                    {a.type === "fbike" && (
                                      <>
                                        {minted ? (
                                          <Link
                                            target="_blank"
                                            to={`https://market.dnaracing.run/asset/core/${getv(m, "hinfo.hid")}`}
                                            className="block hover:bg-r3dark/30 p-3 rounded-lg transition-colors"
                                          >
                                            <div className="flex items-center gap-2 mb-2">
                                              <span className="text-r3lig font-digi text-sm">
                                                #{getv(m, "hinfo.hid")}
                                              </span>
                                              <span className="text-white font-digi">
                                                {getv(m, "hinfo.name")}
                                              </span>
                                            </div>
                                            <div className="grid grid-cols-2 gap-2">
                                              <ElementTag element={getv(m, "hinfo.element")} />
                                              <TypeTag type={getv(a, "info.type")} />
                                              <FNoTag fno={getv(m, "hinfo.fno")} />
                                              <GenderTag gender={getv(m, "hinfo.gender")} />
                                            </div>
                                          </Link>
                                        ) : (
                                          <div className="text-center p-3 bg-r3dark/20 rounded-lg">
                                            <p className="text-gray-300 text-sm">
                                              Random {_.capitalize(getv(a, "info.type"))} Bike F{getv(a, "info.fno")}
                                            </p>
                                          </div>
                                        )}
                                      </>
                                    )}

                                    {["skin", "custom_1v1_skin"].includes(a.type) && (
                                      <>
                                        {minted ? (
                                          <Link
                                            target="_blank"
                                            to={`https://market.dnaracing.run/asset/skin/${getv(m, "skin_info.skinid")}`}
                                            className="block hover:bg-r3dark/30 p-3 rounded-lg transition-colors"
                                          >
                                            <div className="space-y-1 text-sm">
                                              <div className="text-r3lig">
                                                Skin ID: #{getv(m, "skin_info.skinid")}
                                              </div>
                                              <div className="text-gray-300">
                                                <span>Rarity: </span>
                                                <span className="text-r3lig">{getv(m, "skin_info.rarity")}</span>
                                              </div>
                                              <div className="text-gray-300">
                                                <span>Order: </span>
                                                <span className="text-r3lig">{getv(m, "skin_info.name")}</span>
                                              </div>
                                            </div>
                                          </Link>
                                        ) : null}
                                        
                                        <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3">
                                          <p className="text-yellow-300 text-xs">
                                            💬 Please contact staff via Discord support channel
                                          </p>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </GradientCard>
              );
            })}
          </div>
        </GlassCard>
      </div>
    </div>
  );

  return (
    <>
      <GlowButton 
        onClick={() => set_open(true)} 
        variant="secondary" 
        className="text-xs px-3 py-1.5"
      >
        <span className="flex items-center gap-1.5">
          <span>📋</span>
          <span>View Assets</span>
        </span>
      </GlowButton>

      {open && createPortal(
        isSingleAsset ? singleAssetModal() : modalContent,
        document.body
      )}
    </>
  );
};

export const TransactionTable = () => {
  const pcon = usePrizeboxContext();
  const { qo_txns } = pcon;
  const [txns = [], bmap = {}] = useMemo(() => {
    return [
      getv(qo_txns, "data.result.txns"),
      getv(qo_txns, "data.result.boxinfomap"),
    ];
  }, [qo_txns.dataUpdatedAt]);

  // Show skeleton while loading
  if (qo_txns.isLoading || qo_txns.isFetching) {
    return <TransactionTableSkeleton />;
  }

  if (txns.length === 0) {
    return (
      <GlassCard className="mx-auto max-w-4xl mt-2">
        <div className="text-center py-12">
          <div className="text-6xl mb-4 opacity-50">📦</div>
          <h3 className="text-r3lig font-digi text-xl mb-2">
            No Transactions Yet
          </h3>
          <p className="text-gray-400">
            Your transaction history will appear here
          </p>
        </div>
      </GlassCard>
    );
  }

  return (
    <GlassCard className="h-full hover-lift flex flex-col mt-2">
      <div className="p-6 border-b border-r3lig/20 flex-shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-gradient-to-r from-r3reg to-r3dark flex items-center justify-center">
            <span className="text-white text-sm">📋</span>
          </div>
          <h3 className="text-r3lig font-digi text-lg">Recent Activity</h3>
          <div className="flex-1"></div>
          <div className="text-gray-400 resp-text--1">{txns.length}</div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {txns.map((t, idx) => {
          let boxtype = getv(t, "connects.boxtype");
          const isopen = t.type == "open" || t.type == "open_with_options";

          return (
            <div
              key={idx}
              className="group bg-r3dark/10 hover:bg-r3lig/10 border border-r3lig/20 hover:border-r3lig/40 rounded-xl p-3 transition-all duration-300 hover:shadow-lg hover:shadow-r3lig/20"
            >
              {/* Top Row: Transaction Hash + Date */}
              <div className="flex items-center justify-between mb-2">
                <Tag
                  redirect={polytxnidlink(t.id)}
                  className="flex items-center gap-1.5 bg-r3dark/30 hover:bg-r3reg/30 border-r3lig/30 text-r3lig hover:text-white transition-all duration-300 group-hover:scale-105 text-xs"
                >
                  <div className="w-3 h-3">
                    <Img img={polychainimg} />
                  </div>
                  <span className="font-mono">
                    {t.id.slice(0, 4)}...{t.id.slice(-4)}
                  </span>
                </Tag>

                <div className="text-gray-400 text-xs">
                  {iso_format(getv(t, "date"))}
                </div>
              </div>

              {/* Main Content Row */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 flex-1">
                  {t.type == "mint" ? (
                    <>
                      <div className="w-5 h-5 rounded-full bg-orange-500/20 flex items-center justify-center">
                        <span className="text-orange-400 text-xs">⚡</span>
                      </div>
                      <div className="min-w-0">
                        <div className="font-digi text-orange-400 text-sm">
                          MINTED
                        </div>
                        <div className="text-gray-300 text-xs truncate">
                          {getv(t, "connects.qty")} {boxtypemap[boxtype]?.name}
                        </div>
                      </div>
                    </>
                  ) : isopen ? (
                    <>
                      <div
                        className={twMerge(
                          "w-5 h-5 rounded-full flex items-center justify-center",
                          t.blocked ? "bg-red-500/20" : "bg-green-500/20",
                        )}
                      >
                        <span
                          className={twMerge(
                            "text-xs",
                            t.blocked ? "text-red-400" : "text-green-400",
                          )}
                        >
                          {t.blocked ? "❌" : "📦"}
                        </span>
                      </div>
                      <div className="min-w-0 flex-1">
                        <div
                          className={twMerge(
                            "font-digi text-sm",
                            t.blocked ? "text-red-400" : "text-green-400",
                          )}
                        >
                          {t.blocked ? t.blocked_msg : "OPENED"}
                        </div>
                        <div className="text-gray-300 text-xs truncate">
                          {getv(t, "connects.qty")} {boxtypemap[boxtype]?.name}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>

                {/* Actions */}
                {isopen && (
                  <div className="flex-shrink-0 ml-2">
                    <ViewBoxAssets t={t} bmap={bmap} />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </GlassCard>
  );
};


// Context for shared state
export const PrizeboxContext = React.createContext({});
export const usePrizeboxContext = () => React.useContext(PrizeboxContext);
